import React, {useContext} from 'react';
import stylesSample3 from './BusinessCardSample3.module.css'
import {observer} from "mobx-react-lite";
import {Context} from "../../../../../index";
import styles from "../BusinessCard.module.css";

const BusinessCardSample3 = observer(() => {
    const {businessCard} = useContext(Context);

    return (
        <div className={styles.businessCard}>
            <div id='businessCardContent'>
                <div className={`${stylesSample3.background} ${styles.padding}`}>
                    <div className={styles.content}>
                        <div className={stylesSample3.mainInf}>
                            <div className={stylesSample3.name}>
                                {businessCard.name}
                            </div>
                            <div className={stylesSample3.jobTitle}>
                                {businessCard.jobTitle}
                            </div>
                        </div>
                        <div className={stylesSample3.informationBlock}>
                            <div className={stylesSample3.header}>
                                {businessCard.header}
                            </div>
                            <div>
                                {businessCard.phone}
                            </div>
                            <div>
                                {businessCard.email}
                            </div>
                            <div>
                                {businessCard.address}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default BusinessCardSample3;